const mEditionBillingFiscalAuthorizerEditAuthorizer = {
  mEditionBillingFiscalAuthorizerEditAuthorizer: {
    alerts: {
      createAutorizador: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo mas tarde.',
        success: 'El autorizador fiscal fue conectado exitosamente.'
      }
    },

    buttonPrimary: 'Completar Autorización',
    buttonSecondary: 'Volver al listado',

    redirect: 'Espera un momento, serás redireccionado...',
    title: 'Completa tus datos',

    validation: {
      required: 'Información requerida.'
    }
  }
}

export default mEditionBillingFiscalAuthorizerEditAuthorizer
